import { recordListingEvent } from '../../../../Redux/Actions/recordListingEvent';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageGallery from 'react-image-gallery';
import $, { map } from 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import { GET_CAR_WASH_DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import 'react-image-gallery/styles/css/image-gallery.css';
// import Modal from '../../../common/Modal/Modal';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { useTranslation } from 'react-i18next';
import { getCarWashListing } from '../../../../Redux/Actions/UserAction';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/user/car-wash/banner-a.jpg',
  },
];

const openStatus = ['OPEN', 'مفتوح'];

export default function CarWashDetails() {
  const { t } = useTranslation();
  var home = useSelector((state) => state.home);
  const carWashDetail = home?.CarWashAllList?.[0];
  const dispatch = useDispatch();
  const { carWashId } = useParams();
  useEffect(() => { if (carWashId) recordListingEvent(carWashId, 'carWash', 'VIEW'); }, [carWashId]);
  // const [carWashDetail, setCarWashDetail] = useState({});
  const [mapModalOpen, setMapModalOpen] = useState(false);

  const [expandedPackage, setExpandedPackage] = useState(null);

  useEffect(() => {
    if (carWashId && carWashId !== '') dispatch(getCarWashListing(carWashId));
  }, [carWashId, dispatch]);

  console.log('getCarWashDetailList', carWashDetail);

  if (!carWashDetail) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  const togglePackage = (index) => {
    setExpandedPackage(expandedPackage === index ? null : index);
  };

  let bannerImages = defaultImages;

  if (carWashDetail?.businessMedia && carWashDetail.businessMedia.length > 0) {
    const mediaImages = carWashDetail.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  const logo = carWashDetail?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  )?.media?.path;

  //Social Media Data
  const socialMediaData =
    typeof carWashDetail?.socialMedia === 'string'
      ? JSON.parse(carWashDetail?.socialMedia)
      : carWashDetail?.socialMedia;

  //Business Calendar
  const businessCalendar =
    typeof carWashDetail?.calendar === 'string'
      ? JSON.parse(carWashDetail?.calendar)
      : carWashDetail?.calendar;
  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = businessCalendar?.[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  // Only show the open/close badge when there's an actual time to show. With no
  // working hours configured it would otherwise read "Close Now | Open at "
  // (blank), which looks broken.
  const hasHours = isOpen || (!!nextActionTime && `${nextActionTime}`.trim() !== '');

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Location Data
  const gpsData =
    typeof carWashDetail?.gps === 'string'
      ? JSON.parse(carWashDetail?.gps)
      : carWashDetail?.gps;
  const lat = parseFloat(gpsData?.lat);
  const lng = parseFloat(gpsData?.long);

  return (
    <div>
      <div class="user-banner">
        <CommonBanner bannerImages={bannerImages} />

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-4 col-md-3">
                      <img
                        style={{ width: '70px', height: '70px' }}
                        src={logo || 'assets/images/user/car-wash/c.jpg'}
                        alt="assets/images/user/car-wash/c.jpg"
                        class="img-fluid user-garage-logo"
                      />
                    </div>
                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">{carWashDetail?.carWashName}</h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            target="_blank"
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            onClick={() => recordListingEvent(carWashId, 'carWash', 'CONTACT')} href={`https://wa.me/${`${carWashDetail?.whatsAppNumberCountryCode}${carWashDetail?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <CallLink
                            target="_blank"
                            onClick={() => recordListingEvent(carWashId, 'carWash', 'CONTACT')} record={carWashDetail}
                          >
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  {hasHours && (
                    <p class="mb-3">
                      <span class={isOpen ? 'open-time' : 'close-time'}>
                        {isOpen ? t('Open Now') : t('Close Now')}
                      </span>{' '}
                      |{' '}
                      <span class={isOpen ? 'close-time' : 'open-time'}>
                        {isOpen
                          ? `${t('Closes at')} ${nextActionTime}`
                          : `${t('Open at')} ${nextActionTime}`}
                      </span>
                    </p>
                  )}
                  <ul className="list-inline mb-0">
                    {carWashDetail?.website && (
                      <li className="list-inline-item">
                        <a
                          href={externalUrl(carWashDetail?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            className="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => {
                            const status = openStatus.includes(
                              businessCalendar?.[day]?.status
                            );

                            return status ? (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.openTime}
                                </td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.endTime}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">{t('Closed')}</td>
                                <td scope="col">{t('Closed')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content-area">
        <div class="container">
          <h5 className="cav-section-title">{t('About Us')}</h5>
          {carWashDetail?.about?.split('\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}
          {carWashDetail?.packages?.length > 0 && (
            <div>
              <h5 className="cav-section-title">{t('Packages')}</h5>
              {carWashDetail.packages.map((item, i) => (
                <div key={i} style={{ border: '1px solid #e6e8ea', borderRadius: '8px', marginBottom: '8px', overflow: 'hidden', backgroundColor: '#f5f6f7' }}>
                  <div
                    onClick={() => togglePackage(i)}
                    style={{ padding: '9px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: expandedPackage === i ? '#eceef0' : '#f5f6f7' }}
                  >
                    <div>
                      <h5 style={{ fontWeight: '600', marginBottom: '4px', fontSize: '1rem' }}>{item?.packageName}</h5>
                      <span style={{ color: '#FEBA00', fontWeight: '700', fontSize: '1rem' }}>{item?.price}&nbsp;{item?.currency?.toUpperCase()}</span>
                    </div>
                    <i className={`fas fa-chevron-${expandedPackage === i ? 'up' : 'down'}`} style={{ color: '#f0ad4e', fontSize: '1rem' }}></i>
                  </div>
                  {expandedPackage === i && (
                    <div style={{ padding: '0 20px 15px', borderTop: '1px solid #eee' }}>
                      {item?.description && (
                        <p style={{ color: '#333', fontSize: '0.95rem', lineHeight: '1.6', marginTop: '12px', whiteSpace: 'pre-line' }}>{item.description}</p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div class="main-content-area">
        <div class="container">
          {/* <table className="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <td scope="row">Mobile</td>
                    <td>
                          {carWashDetail?.mobileNumbers?.map((dt) => (
                            <>
                              {dt.countryCode}-{dt.mobileNumber}
                            </>
                          ))}
                        </td>
                  </tr>
                  <tr>
                    <td>Location</td>
                    <td>{carWashDetail?.location}</td>
                  </tr>
                  <tr>
                    <td>Website</td>
                    <td>
                      <a href={externalUrl(carWashDetail?.website)} target="_blank">
                        {carWashDetail?.website}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table> */}
        </div>
      </div>
    </div>
  );
}
